export default "20260424.1 \r\n"